import React from "react";
import { HourMarker } from "./HourMarker/Master";
import { Lug, LugGradient } from "./Lug/Master";
import { MinuteMarker } from "./MinuteMarker/Master";
import { Strap, StrapGradient } from "./Strap/Master";

const SvgComponent = (
  { types: { lug, strap, minuteMarker, hourMarker }, colors, isAnimated, isReflect },
  props
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 2880" {...props}>
      <style>
        {`@font-face {
          font-family: Comfortaa;
          font-style: normal;
          font-weight: 400;
          src: url("data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAXMAA0AAAAACJwAAxrhAAAAAAAAAAAAAAAAAAAAAAAAAABHUE9TAAABMAAAAFAAAABuK8wkkE9TLzIAAAGAAAAATgAAAGBoJCImY21hcAAAAdAAAABEAAABSgC8BJNnYXNwAAACFAAAAAgAAAAIAAAAEGdseWYAAAIcAAABJwAAAVCIoSzEaGVhZAAAA0QAAAA2AAAANhzxVTRoaGVhAAADfAAAABsAAAAkA3MB3WhtdHgAAAOYAAAADAAAAAwGWQBkbG9jYQAAA6QAAAAIAAAACACiAQ5tYXhwAAADrAAAABoAAAAgAAgAUG5hbWUAAAPIAAAB5wAAA5MwPoSDcG9zdAAABbAAAAAUAAAAIP+fADVwcmVwAAAFxAAAAAcAAAAHaAaMhXicY2BkYGDgYlBhMGJgcnHzCWHgy0ksyWPgY2ABijP8/88AkmfMTi3KY+AAscCYhYEJyGMEYiYGCbBKDQYFIJuJAQYYgWwIhkEwGwBqLgeneJxjYGGSZZzAwMrAwNTFFMHAwOANoRnjGIwYPRiQwAIGpv8CSHznyCBXhgMMCgwpzIX/xRgYWFkZfRQYGOeD5JiUmXmBlAIDMwANOArLAAB4nGNgYGBmgGAZBkYGEHAB8hjBfBYGDSDNBqQZGZgYFBhS/v8H8sH0/0f/50LVAwEjGwNBwERYCUHASFjJgAEAJfwJTQABAAH//wAPeJxVT8tOwkAUvTNK2XRK7tgOqcSatukjCGigjwCVhQ+wRsHEJQTWJn6BCSz8E7/CD3HpF7hw6cqITmHlTc69OefmJOfALgQA9HqHQQVqcAgjgNTxY4ySjt0WBuqKG0guqWS6UrbR3tvwdEDjyHcdRapuoQxIp20RQ9dIWZNHuVARVfJR7C9umlzik7yu83cNa0J3RBQeRZwxHo5ajctgv25WKhxQpW+F46ep4vPGI3FDX9YeZweZwe3Q8k6iBkNkzWHgndW9qF5loWAcZA04/f2mD7KLAB+g5LTINpao4rYAajRoD6TaIq5TpLQIuZ+s8tHT7fmjLRAFzZfj3jSOp73uLElmpXx1J//dY+Jzw+DrcLy8GqbzrL9IkkU/m6fwf/4AtZs18wAAAQAAAAMa4c0/ggZfDzz1CAMD6AAAAADWKK8ZAAAAAN0fR08AJ//7AmkDDQAAAAYAAgAAAAAAAHicY2BkYGAu/C/GwMB0mAECGBlQATMAQgkCVAACcQAnAsMAPQElAAAAAABmAKIAqHicY2BkYGBgZvBgYGEAAUYGBGAHEQAIKABZAAB4nIVRQU7bQBR9dgIVi0Ztl6iLUVYggR1DkSqyQhFZIUARQmLRhTGDbWRnrJlJAt12xw24QK/QC1S9QU/QA3TT7vvsDCkFpGY0mTf/v/fm5QfAK3yDh/nnI/cce1jhbY59vMAnh1t4i1uH23iNzw4v4SW+OLzM+leHO1jFd6q89gpvv/DTYQ9vvB8O++h4vx1u4b3fcriNrt93eAmr/geHl1mfOdzBO/9uoKobnaeZFVu9KBInmRQDVV4qbeNYHGt1JRMr9iY2U9qItczayuyGYZrbbHIeJKoM40Jey3wah8m9bH1DzNgXI2mknsoLMVRjKw7jUoruwrsbLOBIppMi1ttB1NvpD85G+/1Fa9P1/kZyhVOpTa7GohE9odcxmdIkOq+sCUxeBEqn4dHwAAMoVLiBRo4UGSwEttBDxCVwworkWbNKXPJbkxFzCRwTK1yxnzSqPUx4Zg3H8L7WuFm6G+wi5Er5Rs2Y4BwBVbVnSK+CHtfcOaa8ha7z8LV1bNBx5vQCI7INt6ZC4oKVIdnjJsch+WWTuvtM7i5fflqt/VLmKog1tsmJOIMd9Mk9Y3e/QY9Vm490z03pX8Zpk9nwd9RpxYOX/u9+P835LA2nVP9nFWuGLrVnwbPWp+wfcSIHfwDv+rf/AHicY2BmAIP/cxiMGDABMwAqhgHUuAH/hbAEjQA=") format("woff")
        }

        @font-face {
          font-family: Monda;
          font-style: normal;
          font-weight: 400;
          src: url("data:application/font-woff;charset=utf-8;base64,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") format("woff")
        }
        
        text.minute-marker {
          font-family:Monda;
        }

        text.logo {
          font-family:Comfortaa;
        }
      `}
      </style>
      <defs>
        <LugGradient type={lug} isAnimated={isAnimated} colors={colors?.lug} />
        <StrapGradient type={strap} isAnimated={isAnimated} colors={colors?.strap} />
        <linearGradient
          className="background-gradient"
          id="f"
          gradientUnits="objectBoundingBox"
          x1={0.483}
          y1={0}
          x2={0.5}
          y2={0.991}
          spreadMethod="pad"
        >
          <stop
            stopColor={colors?.background?.gradient1}
            className="stop-1"
            offset={0}
          />
          <stop
            stopColor={colors?.background?.gradient2}
            className="stop-2"
            offset={1}
          />
        </linearGradient>
        <linearGradient
          className="outer-gradient"
          id="e"
          gradientUnits="objectBoundingBox"
          x1="0.493433394823702"
          y1="5.55111512312578e-17"
          x2="0.49301259988227"
          y2="0.957786184595154"
          spreadMethod="pad"
        >
          <stop
            stopColor={colors?.outerFrame?.gradient1}
            offset="0.0405"
            stopOpacity="1"
          >
            {isAnimated && (
              <animate
                attributeName="stop-color"
                values={[
                  colors?.outerFrame?.gradient1,
                  colors?.outerFrame?.gradient2,
                  colors?.outerFrame?.gradient1,
                ].join(";")}
                dur="4s"
                repeatCount="indefinite"
              />
            )}
          </stop>
          <stop
            stopColor={colors?.outerFrame?.gradient2}
            offset="1"
            stopOpacity="1"
          >
            {isAnimated && (
              <animate
                attributeName="stop-color"
                values={[
                  colors?.outerFrame?.gradient2,
                  colors?.outerFrame?.gradient1,
                  colors?.outerFrame?.gradient2,
                ].join(";")}
                dur="4s"
                repeatCount="indefinite"
              />
            )}
          </stop>
        </linearGradient>
      </defs>
      <Lug type={lug} colors={colors?.lug} />
      <Strap type={strap} colors={colors?.strap} />
      <circle
        className="outer-frame"
        transform="translate(87.36 928.32)"
        r={511.68}
        cx={511.68}
        cy={511.68}
        fill="url(#e)"
        stroke={colors?.outerFrame?.stroke}
        strokeWidth={9.6}
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <circle
        className="inner-frame"
        transform="matrix(1 0 0 1 149.76 989.76)"
        r={450.24}
        cx={450.24}
        cy={450.24}
        fill={colors?.innerFrame?.fill}
        stroke={colors?.innerFrame?.stroke}
        strokeWidth={4.8}
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <circle
        className="background"
        transform="translate(163.08 1003.08)"
        r={436.92}
        cx={436.92}
        cy={436.92}
        fill="url(#f)"
        fillRule="evenodd"
        stroke={colors?.background?.stroke}
        strokeWidth={0.48}
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <MinuteMarker type={minuteMarker} colors={colors?.minuteMarker} />
      <HourMarker type={hourMarker} colors={colors?.hourMarker} />
      <text
        className="logo"
        transform="matrix(-.43098 -.43098 .43098 -.43098 601.987 1261.177)"
        fill={colors?.logo?.fill}
        strokeOpacity={0}
        stroke={colors?.logo?.stroke}
        strokeWidth={0}
        strokeLinecap="square"
        strokeLinejoin="bevel"
        fontFamily="Comfortaa"
        fontSize={90}
        fontSizeAdjust={0.491}
        letterSpacing={0}
        wordSpacing={0}
      >
        <tspan x={0}>{"d"}</tspan>
      </text>
      <text
        className="logo"
        transform="matrix(-.43098 .43098 -.43098 -.43098 601.972 1256.15)"
        fill={colors?.logo?.fill}
        strokeOpacity={0}
        stroke={colors?.logo?.stroke}
        strokeWidth={0}
        strokeLinecap="square"
        strokeLinejoin="bevel"
        fontFamily="Comfortaa"
        fontSize={90}
        fontSizeAdjust={0.491}
        letterSpacing={0}
        wordSpacing={0}
      >
        <tspan x={0}>{"d"}</tspan>
      </text>
      <text
        className="logo"
        transform="rotate(-45 1820.656 -90.02) scale(.60949)"
        fill={colors?.logo?.fill}
        strokeOpacity={0}
        stroke={colors?.logo?.stroke}
        strokeWidth={0}
        strokeLinecap="square"
        strokeLinejoin="bevel"
        fontFamily="Comfortaa"
        fontSize={90}
        fontSizeAdjust={0.491}
        letterSpacing={0}
        wordSpacing={0}
      >
        <tspan x={0}>{"d"}</tspan>
      </text>
      <text
        className="logo"
        transform="rotate(45 -1217.73 1348.6) scale(.60949)"
        fill={colors?.logo?.fill}
        strokeOpacity={0}
        stroke={colors?.logo?.stroke}
        strokeWidth={0}
        strokeLinecap="square"
        strokeLinejoin="bevel"
        fontFamily="Comfortaa"
        fontSize={90}
        fontSizeAdjust={0.491}
        letterSpacing={0}
        wordSpacing={0}
      >
        <tspan x={0}>{"d"}</tspan>
      </text>
    </svg>
  );
};

export default SvgComponent;
